$('.tabs__nav li')
	.not('.tab--all')
	.click(function (e) {
		e.preventDefault()
		var tabNav = $(this).parent()
		var tabLi = $('li', tabNav)

		var tabsWrapper = $(this).parent().parent()
		var tabIndex = $(this).index(tabLi)

		$('.tab', tabsWrapper).removeClass('tab--active')
		$('.tab:eq(' + tabIndex + ')', tabsWrapper).addClass('tab--active')

		$('li', tabNav).removeClass('active')
		$(this).addClass('active')
	})
